import { Dialog,Button, DialogContent, DialogActions } from '@material-ui/core'
import React from 'react'
import SecondaryButton from '../SecondaryButton';
import Opcion from './Opcion';

const OpcionesModal = ({opciones,idProducto}) => 
{
    const [OpenModal, setOpenModal] = React.useState(false);

    const changeStatus=() => setOpenModal(!OpenModal)

    if(opciones===undefined)
    {
        return "";
    }

    return <>
     <Button variant="contained" color="primary" onClick={changeStatus}>Opciones</Button>
     <Dialog open={OpenModal} onClose={changeStatus}>
        <DialogContent>
            <div>
                {Object.values(opciones).map(opcion => <Opcion opcion={opcion}/>)}
            </div>
        </DialogContent>
        <DialogActions>
            <SecondaryButton onClick={changeStatus}>Cancelar</SecondaryButton>
            <Button color="primary" variant="contained" onClick={() => ""}>Confirmar</Button>
        </DialogActions>
     </Dialog>
    </>
}

export default OpcionesModal
